/**
 * Crea los botones para jugar
 * @param {*} scene
 */
export function crearBotones(scene) {
  //BOTON SUBIR APUESTA
  scene.botonSubirApuesta = scene.add
    .image(209, 387, "botonSubirApuestaEstatico")
    .setInteractive();
  scene.botonSubirApuesta.setDepth(300);

  scene.botonSubirApuesta.on("pointerover", () => {
    if (!scene.noVaMas) {
      scene.botonSubirApuesta.setTexture("botonSubirApuestaHover");
    }
  });

  scene.botonSubirApuesta.on("pointerout", () => {
    if (!scene.noVaMas) {
      scene.botonSubirApuesta.setTexture("botonSubirApuestaEstatico");
    }
  });

  scene.botonSubirApuesta.on("pointerdown", () => {
    if (!scene.noVaMas) {
      scene.botonSubirApuesta.setTexture("botonSubirApuestaPressed");
    }
  });

  scene.botonSubirApuesta.on("pointerup", () => {
    if (!scene.noVaMas) {
      if (scene.botonSubirApuesta.input?.isOver) {
        scene.botonSubirApuesta.setTexture("botonSubirApuestaEstatico");
      } else {
        scene.botonSubirApuesta.setTexture("botonSubirApuestaHover");
        scene.subirApuesta();
      }
    }
  });

  //BOTON BAJAR APUESTA
  scene.botonBajarApuesta = scene.add
    .image(376, 387, "botonBajarApuestaEstatico")
    .setInteractive();
  scene.botonBajarApuesta.setDepth(300);

  scene.botonBajarApuesta.on("pointerover", () => {
    if (!scene.noVaMas) {
      scene.botonBajarApuesta.setTexture("botonBajarApuestaHover");
    }
  });

  scene.botonBajarApuesta.on("pointerout", () => {
    if (!scene.noVaMas) {
      scene.botonBajarApuesta.setTexture("botonBajarApuestaEstatico");
    }
  });

  scene.botonBajarApuesta.on("pointerdown", () => {
    if (!scene.noVaMas) {
      scene.botonBajarApuesta.setTexture("botonBajarApuestaPressed");
    }
  });

  scene.botonBajarApuesta.on("pointerup", () => {
    if (!scene.noVaMas) {
      if (scene.botonBajarApuesta.input?.isOver) {
        scene.botonBajarApuesta.setTexture("botonBajarApuestaEstatico");
      } else {
        scene.botonBajarApuesta.setTexture("botonBajarApuestaHover");
        scene.bajarApuesta();
      }
    }
  });

  //BOTON JUGAR APUESTA
  scene.botonJugarApuesta = scene.add
    .image(542, 387, "botonJugarApuestaEstatico")
    .setInteractive();
  scene.botonJugarApuesta.setDepth(300);

  scene.botonJugarApuesta.on("pointerover", () => {
    if (!scene.noVaMas) {
      scene.botonJugarApuesta.setTexture("botonJugarApuestaHover");
    }
  });

  scene.botonJugarApuesta.on("pointerout", () => {
    if (!scene.noVaMas) {
      scene.botonJugarApuesta.setTexture("botonJugarApuestaEstatico");
    }
  });

  scene.botonJugarApuesta.on("pointerdown", () => {
    if (!scene.noVaMas) {
      scene.botonJugarApuesta.setTexture("botonJugarApuestaPressed");
    }
  });

  scene.botonJugarApuesta.on("pointerup", () => {
    if (!scene.noVaMas) {
      if (scene.botonJugarApuesta.input?.isOver) {
        scene.botonJugarApuesta.setTexture("botonJugarApuestaEstatico");
      } else {
        scene.botonJugarApuesta.setTexture("botonJugarApuestaHover");
        scene.jugarApuesta();
      }
    }
  });
}
